import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import { equipmentsListKey } from './useEquipmentsListInfiniteQuery';
import { equipmentsLogListKey } from './useEquipmentsLogListInfiniteQuery';

const equipmentsActivateFn = (data: { equipments: number[] }) =>
  apiClient.post(`${APP_API_URL}equipments/activate`, data);

export const useEquipmentsActivateMutation = () => {
  const queryClient = useQueryClient();
  const locationSelectValue = selectAppLocationSelectValue();

  return useMutation({
    mutationFn: equipmentsActivateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentsListKey({})[0]] });
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentsLogListKey({})[0]] });
      }, timeoutDelay);
    },
  });
};
